import { render } from "./ClientTouches.vue?vue&type=template&id=69b18092"
import script from "./ClientTouches.vue?vue&type=script&lang=js"
export * from "./ClientTouches.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__